import React from "react";
import "../App.css";
import Footer from "../components/Footer";

function Products() {
    return (
        <>
            <h1 className="products">PRODUCTS</h1>
            <Footer />
        </>
    );
}

export default Products;
